import { useNavigate } from "react-router-dom";
import Typography from "../../Typography";
import IconButton from "../../IconButton";
import {
  PodcastImage,
  PodcastCard as StyledPodcastCard,
  PodcastTitle,
  PodcastInfo,
  PodcastRatingStar,
  PodcastDescription,
  LiveFlag,
  PodcastImageWrapper,
  PodcastActions,
  DetailInfoButton,
  TitleWrapper,
} from "./styled";
import LiveIcon from "../../LiveIcon";
import { PlayAudioButton } from "../../PlayAudioButton/PlayAudioButton";
import { getReleaseEnding } from "../../../utils/utils";
import { AdultIconWithTooltip } from "../../AdultIconWithTooltip";

// Используется для создания последовательной анимации появления карточек подкастов.
// Значение вычисляется на основе индекса карточки в массиве (или 1, если индекс равен 0),
// что создает эффект появления карточек одна за другой с небольшими задержками.

export const PodcastCardSlider = ({
  podcast,
  podcastReleases,
  showProgress = false,
  duration,
}) => {
  let navigate = useNavigate();
  const liveRelease = podcastReleases.find((releaseItem) => releaseItem.isLive);
  const release = podcastReleases.filter(
    (releaseItem) => !releaseItem.isLive,
  )[0];

  const playlistReleases = [
    release,
    ...podcastReleases.filter((item) => item.id !== release?.id),
  ];

  return (
    <StyledPodcastCard
      key={podcast.id}
      duration={duration * 500}
      onClick={() => navigate(`/podcasts/${podcast.podcastLink}`)}
      tabIndex={0}
    >
      <PodcastImageWrapper>
        <PodcastImage src={podcast.cover.big} alt={podcast.title} />
        {Object.keys(podcast.live).length > 0 && (
          <LiveFlag>
            <LiveIcon size="15" />
            <Typography component="span" variant="h2">
              ЛАЙВ
            </Typography>
          </LiveFlag>
        )}
        <PodcastActions>
          <PlayAudioButton
            trackOrRelease={liveRelease ?? release}
            audioFileLink={release?.audioFileLink}
            playlistReleases={playlistReleases}
          />
          <IconButton as={DetailInfoButton}>
            <img src="/arrow-up.svg" alt="Детальная информация" />
          </IconButton>
        </PodcastActions>
      </PodcastImageWrapper>
      <div>
        <TitleWrapper>
          <Typography as={PodcastTitle} variant="h4">
            {podcast.title}
          </Typography>
          {podcast.isAdult && <AdultIconWithTooltip />}
        </TitleWrapper>
        <PodcastInfo>
          <PodcastRatingStar src="/star.svg" alt={podcast.avgRating} />
          <Typography>
            {podcast.avgRating} ({podcast.countRatings})
          </Typography>
          •
          <Typography>
            {podcast.countPodcastReleases}{" "}
            {getReleaseEnding(podcast.countPodcastReleases)}
          </Typography>
        </PodcastInfo>
      </div>
      <Typography as={PodcastDescription} color="secondary">
        {podcast.description}
      </Typography>
    </StyledPodcastCard>
  );
};
